import { render } from "./BuildingInfo.vue?vue&type=template&id=0ef278ad&scoped=true"
import script from "./BuildingInfo.vue?vue&type=script&lang=js"
export * from "./BuildingInfo.vue?vue&type=script&lang=js"

import "./BuildingInfo.vue?vue&type=style&index=0&id=0ef278ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef278ad"]])

export default __exports__